<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns1"
      :loading="modalLoading"
      :data="queryStorageGatewayByGroupIdList"
      style="width: 100.1%;"
    >
      <template slot-scope="{ row, index }" slot="actions">
        <span @click="doDelete(index)">
          <Button
            type="error"
            size="small"
            @click="storageGatewayDelmodal = true"
            >{{ $t("alarms.common.delete") }}</Button
          >
        </span>
      </template>
    </Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>

    <Modal v-model="storageGatewayDelmodal" width="360" :mask-closable="false">
      <p slot="header" style="color:#ff6600;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align:center">
        <p>
          {{ $t("alarms.common.sureDelete") }} {{ Name }}
          {{ $t("alarms.common.what") }}?
        </p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          @click="deleteStorageGateway()"
          :disabled="isDisable"
          >{{ $t("alarms.common.delete") }}</Button
        >
      </div>
    </Modal>
  </div>
</template>
<script>
let tableStorageGateways = {};
export default {
  name: "TableStorageGateways",
  props: ["getAccountType"],
  data() {
    return {
      accountType: "",
      accountName: "",
      storageGatewayId: "",
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      Name: "",
      modalLoading: true,
      storageGatewayDelmodal: false,
      isDisable: false,
      columns1: [
        {
          title: this.$t("permission_configuration_management.group.account"),
          key: "accountName"
        },
        {
          title: this.$t(
            "permission_configuration_management.group.accountType"
          ),
          key: "accountTypeName"
        },
        {
          title: this.$t(
            "permission_configuration_management.group.storageGatewayID"
          ),
          key: "storageGatewayId"
        },
        {
          title: this.$t(
            "permission_configuration_management.group.storageGatewayName"
          ),
          key: "storageGatewayName",
          width: "120px"
        },
        {
          title: this.$t("permission_configuration_management.group.region"),
          key: "region"
        },
        {
          title: this.$t("common.operation"),
          slot: "actions"
        }
      ],
      queryStorageGatewayByGroupIdList: [
        {
          name: ""
        }
      ]
    };
  },
  beforeCreate: function() {
    tableStorageGateways = this;
  },
  methods: {
    // 点击备份目标的时候显示实例列表
    queryStorageGatewaysByGroupId: function() {
      eventBus.$on("accountName", function(val) {
        tableStorageGateways.accountName = val;
      });
      eventBus.$on("accountType", function(val) {
        tableStorageGateways.accountType = val;
      });
      eventBus.$on("storageGatewayId", function(val) {
        tableStorageGateways.storageGatewayId = val;
      });
      tableStorageGateways.$api.storageGateway
        .selectQueryStorageGatewaysByGroupId({
          groupId: this.$route.query.id,
          pageNum: this.current,
          pageSize: this.pageSize,
          accountType: this.getAccountType,
          accountName: tableStorageGateways.accountName,
          storageGatewayId: tableStorageGateways.storageGatewayId
        })
        .then(res => {
          this.modalLoading = false;
          this.queryStorageGatewayByGroupIdList = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        })
        .catch(res => {
          // 如果列表里没数据 返回
          this.queryStorageGatewayByGroupIdList = undefined;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableStorageGateways.queryStorageGatewaysByGroupId();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableStorageGateways.queryStorageGatewaysByGroupId();
    },
    // 显示所有数据
    showAllStorageGateway: function() {
      tableStorageGateways.queryStorageGatewaysByGroupId();
    },
    doDelete: function(index) {
      this.lineIndex = index;
      this.Name = this.queryStorageGatewayByGroupIdList[index].name;
    },
    // 删除storageGateway
    deleteStorageGateway: function() {
      this.isDisable = true; // 开始可以点击
      var lineIndex = this.lineIndex;
      // 删除网关
      tableStorageGateways.$api.groupStorageGatewayRelation
        .deleteGroupStorageGatewayRelation({
          groupId: this.$route.query.id,
          storagegatewayId: this.queryStorageGatewayByGroupIdList[lineIndex].id
        })
        .then(res => {
          setTimeout(() => {
            // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
            //21条  3页  2*10+1时删除
            if (
              lineIndex == 0 &&
              (this.current - 1) * this.pageSize + 1 == this.dataTotal
            ) {
              this.current = this.current - 1;
            }
            this.dataTotal = this.dataTotal - 1;
            tableStorageGateways.queryStorageGatewaysByGroupId();
            this.isDisable = false;
            this.storageGatewayDelmodal = false;
            this.$Message.success(this.$t("common.deleteSuccess"));
          }, 1000);
        });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/resource_permission/TableStorageGateways.vue